
      import Custom from './custom.vue'
      import type { App, Plugin } from 'vue'

      export const CustomPlugin: Plugin = {
        install(app: App) {
          app.component('Custom', Custom)
        },
      }
      export { Custom }
      